import { render, staticRenderFns } from "./AddEnterpriseConnection.vue?vue&type=template&id=22018dc0&scoped=true&"
import script from "./AddEnterpriseConnection.vue?vue&type=script&lang=js&"
export * from "./AddEnterpriseConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22018dc0",
  null
  
)

export default component.exports